import { ChangeDetectorRef, Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Country, CountryService } from 'taxtank-core';
import { NgControl } from '@angular/forms';
import { AbstractAutocompleteComponent } from '../abstract-autocomplete/abstract-autocomplete.component';
import { Observable, of } from 'rxjs';

/**
 * Country autocomplete
 */
@Component({
  selector: 'app-country-autocomplete',
  templateUrl: './country-autocomplete.component.html',
  styleUrls: ['./country-autocomplete.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CountryAutocompleteComponent extends AbstractAutocompleteComponent<Country> implements OnInit {
  @Input() label = 'Country';
  @Input() placeholder = 'Search country';
  @Input() showCallingCode: boolean;
  @Input() minSearchLength = 0;

  public ngControl = inject(NgControl);
  protected changeDetectorRef = inject(ChangeDetectorRef);
  private countryService = inject(CountryService);

  getOptions$(): Observable<Country[]> {
    return of(this.countryService.getCache().toArray());
  }
}
